import KAutocomplete from "./KAutocomplete";
import KChip from "./KChip";
import KListTile from "./KListTile";
import { getObjectValueByPath } from "vuetify/lib/util/helpers";

export default {
	name: "KAvatarAutocomplete",

	extends: KAutocomplete,

	props: {
		chips: {
			default: true,
			type: Boolean
		},

		itemSelectionText: String,

		noDataText: {
			default: "Nothing to display",
			type: String
		}
	},

	render() {
		return <KAutocomplete
			attrs={{ ...this.$props }}
			on={{ ...this.$listeners }}
			scopedSlots={{
				item: ( { attrs, item, on } ) =>
					<KListTile
						attrs={{
							...attrs,
							avatar: true,
							identifier: item.id,
							text: getObjectValueByPath( item, this.itemText )
						}}
						on={on}
					></KListTile>,

				selection: data =>
					<KChip
						avatar
						close={this.deletableChips}
						identifier={data.item.id}
						inputValue={data.selected}
						on={{ "click:close": () => data.parent.onChipInput( data.item ) }}
						small={this.smallChips}
						text={getObjectValueByPath( data.item, this.itemSelectionText || this.itemText )}
					></KChip>,

				...this.$scopedSlots
			}}
		>
			{Object.keys( this.$slots ).map( slot =>
				<template slot={slot} key={slot}>{this.$slots[slot]}</template>
			)}
		</KAutocomplete>;
	}
};
